import { useTranslation } from 'react-i18next';
import { Sidepanel } from '@/components/layout/Sidepanel';
import { UserProfileView } from '@/features/user/components/UserProfileView';
import type { UserSidePanelContent } from '../types';
import { SidebarContent } from '@/components/layout/sidepanel/SidebarFooter';

interface UserSidePanelHandlerProps {
  content: UserSidePanelContent | null;
  panelKey: string | null;
  isOpen: boolean;
  onClose: () => void;
}

export function UserSidePanelHandler({
  content,
  panelKey,
  isOpen,
  onClose,
}: UserSidePanelHandlerProps) {
  const { t } = useTranslation();

  if (!content || !panelKey) return null;

  return (
    <Sidepanel
      key={panelKey}
      isOpen={isOpen}
      onClose={onClose}
      title={t('users.sidePanel.title')}
    >
      {content.type === 'view' && (
        <SidebarContent>
          <div>
            <UserProfileView userId={content.userId} showAddToCompany />
          </div>
        </SidebarContent>
      )}
    </Sidepanel>
  );
}
